const constants = require('@/util/constants')
require('./config')

/**
 * 分页查询通知
 */
export function queryNotices (page, size, successcb, failedcb) {
  axios.get('/api/notice/query', {
    params: {
      'page': page,
      'size': size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

export function queryWorkGroupNotices (page, size, successcb, failedcb) {
  axios.get('/api/notice/query/workGroup', {
    params: {
      'page': page,
      'size': size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}
